const filters = [
  'concatName2',
  'concatName3',
  'concatName4',
  'colones',
  'colones2',
  'colones3',
  'dollarize',
  'dollarize2',
  'formatDate',
  'formatDateCompact',
  'formatDateLong',
  'formatDateTab',
  'formatDateTime',
  'formatDateZeroPad',
  'formatTime',
  'formatTimeAgo',
  'projectId',
  'titleize',
  'titleizePayrollType'
]

const context = require.context("../filters", true, /\.js$/)
filters.forEach(name => {
  context(`./${name}.js`)
})
